import {useKeycloak} from "@react-keycloak/web";

import {BrowserRouter, Switch} from "react-router-dom";
import {Route} from "react-router";
import {Spin} from "antd";
import PrivateRoute from "../security/PrivateRoute";

import MainRemoteVideoView from "../components/video/remote/MainRemoteVideoView";
import MainLocalVideoListViewPage from "../pages/localvideolist/page";
import MainLocalVideoViewPage from "../pages/localvideoview/page";
import AdminWelcomePage from "../pages/adminwelcome/page";
import CustomerWelcomePage from "../pages/customerwelcome/page";
import SignupPage from "../pages/signup/page";
import MainLayout from "../pages/layout/MainLayout";
import SignInPage from "../pages/signIn/page";
import AccountType from "../pages/accountType/page";
import StepperContainerIndividualAccount from "../pages/individualAccount/page";
import VideoAppointment from "../pages/videoAppointment/page";

import DocumentAndDetailsVerification from "../pages/admin/documentAndDetailsVerification/page";
import DocumentVerificationWorkBasket from "../pages/admin/documentVerificationWorkBasket/page";
import CustomerVerificationDetails from "../pages/admin/customerVerificationTableDetails/page";
import CustomerVerificationFormDetails from "../pages/admin/customerVerificationFormDetails/page";
import JointAccountRequestList from "../pages/jointAccountRequestList/page";
import AdminHomePage from "../components/common/home/AdminHomePage";
import JointAccountTemplateRequestList from "../pages/jointAccountTemplateRequestList/page";
import JointAccountTemplateRequest from "../pages/admin/jointAccountTemplateRequest/page";
import IndividualAccountComp from "../pages/existingAccount/individualAccountComp";
import SecondApplicantData from "../pages/existingAccount/secondApplicantData";
import IndividualAccountRequest from "../pages/admin/individualAccountRequest/page";
import CustomerRequestsPage from "../pages/customerRequests/customerRequestsPage";
import CustomerRequestsListPage from "../pages/admin/customerRequestsList/customerRequestsListPage";
import SwitchTemplatePage from "../pages/customerTemplates/switchTemplatePage";
import InvestTemplatePage from "../pages/customerTemplates/investTemplatePage";
import TransferTemplatePage from "../pages/customerTemplates/transferTemplatePage";
import WithdrawTemplatePage from "../pages/customerTemplates/withdrawTemplatePage";
import InvestMoneyRequestsComp from "../components/admin/customerTransactionsRequestsList/investMoneyRequestsComp";
import WithdrawMoneyRequestsComp from "../components/admin/customerTransactionsRequestsList/withdrawMoneyRequestsComp";
import TransferMoneyRequestsComp from "../components/admin/customerTransactionsRequestsList/transferMoneyRequestsComp";
import SwitchMoneyRequestsComp from "../components/admin/customerTransactionsRequestsList/switchMoneyRequestsComp";
import InvestReconciliationPage from "../pages/admin/investReconciliation/page";
import TransactionHistoryPage from "../pages/transactionHistory/page";
import Dashboard from "../pages/customerDashboard/page";

import ChangePassword from "../components/changePassword/changePassword";

import InvestRequestPage from "../pages/admin/backOfficeTransactionRequest/investRequestPage";
import SwitchRequestPage from "../pages/admin/backOfficeTransactionRequest/switchRequestPage";
import TransferRequestPage from "../pages/admin/backOfficeTransactionRequest/transferRequestPage";
import WithdrawRequestPage from "../pages/admin/backOfficeTransactionRequest/withdrawRequestPage";
import FundDetails from "../pages/admin/manageParameters/fundDetails/page";
import CustomerDetailsTablePage from "../pages/admin/customerDetails/customerDetailsTable";
import CustomerDetailsViewPage from "../pages/admin/customerDetails/customerDetailsView";
import InvestRetryRequestList from "../pages/admin/investRetry/page";
import RMDashboardPage from "../pages/managerDashboard/rmDashboard/page";
import ManagerDashboard from "../pages/managerDashboard/page";
import InternalUsersList from "../pages/admin/internalUsers/page";
import InvestReconciliationAuth from "../components/admin/investReconciliationAuth/page";
import TableResync from "../components/admin/tableResync/page";
import InvestReconciliationExcelView from "../components/admin/investReconciliationExcelView/page";
import AdminTransactionHistoryPage from "../pages/admin/customerTransactionHistory/page";
import CustomerJourneyStatusPage from "../pages/admin/customerJourneyStatus/page";
import CustomerJourneyStatusViewPage from "../pages/admin/customerJourneyStatusView/page";
import ExistingTemplate from "../pages/existingTemplate/page";


export const AppRouter = () => {
    const {initialized} = useKeycloak();

    if (!initialized) {
        return (
            <div className="loader-container">
                <Spin size="large"></Spin>
            </div>
        );

    }
    return (
        <>
            <BrowserRouter>
                <Switch>
                    <Route
                        exact
                        path={["/"]}
                        component={CustomerWelcomePage}
                    />
                    <Route
                        exact
                        path={["/signup"]}
                        component={SignupPage}
                    />
                    {/*TODO - verify and remove*/}
                    <Route
                        exact
                        path={["/signIn"]}
                        component={SignInPage}
                    />
                    <PrivateRoute
                        roles={["view-user-details"]}
                        exact
                        path={["/account-type-selection"]}
                        component={AccountType}
                    />
                    <PrivateRoute
                        roles={["view-user-details"]}
                        exact
                        path={["/create-individual-account"]}
                        component={StepperContainerIndividualAccount}
                    />
                    <PrivateRoute
                        roles={["view-user-details"]}
                        exact
                        path={["/create-joint-account"]}
                        component={StepperContainerIndividualAccount}
                    />
                    <PrivateRoute
                        roles={["view-user-details"]}
                        exact
                        path={["/make-video-appointment"]}
                        component={VideoAppointment}
                    />


                    <Route
                        exact
                        path={["/admin"]}
                        component={AdminWelcomePage}
                    />
                    <PrivateRoute
                        roles={["view-user-details"]}
                        exact
                        path={["/layout"]}
                        component={MainLayout}
                    />
                    <PrivateRoute
                        roles={["view-user-details"]}
                        path="/workflow/remote/:remoteUserAccessToken"
                        exact
                        component={MainRemoteVideoView}
                    />

                    <Route path="/workflow/:path?">
                        <MainLayout>
                            <Switch>
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/dashboard"
                                    exact
                                    component={AdminHomePage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/customer/dashboard"
                                    exact
                                    component={Dashboard}
                                />

                                {/*<PrivateRoute*/}
                                {/*    roles={["view-user-details"]}*/}
                                {/*    path="/workflow/customer/dashboard2"*/}
                                {/*    exact*/}
                                {/*    component={MainHomePage}*/}
                                {/*/>*/}
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/localvideolist"
                                    exact
                                    component={MainLocalVideoListViewPage}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/local/:callId"
                                    exact
                                    component={MainLocalVideoViewPage}
                                />

                                {/*<PrivateRoute*/}
                                {/*    roles={["view-user-details"]}*/}
                                {/*    path="/workflow/remote/:remoteUserAccessToken"*/}
                                {/*    exact*/}
                                {/*    component={MainRemoteVideoView}*/}
                                {/*/>*/}
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/documentVerificationWorkBasket"
                                    exact
                                    component={DocumentVerificationWorkBasket}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/documentAndDetailsVerification"
                                    exact
                                    component={DocumentAndDetailsVerification}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customerVerification"
                                    exact
                                    component={CustomerVerificationDetails}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customerVerificationDetails"
                                    exact
                                    component={CustomerVerificationFormDetails}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/jointAccountTemplateRequests"
                                    exact
                                    component={JointAccountTemplateRequest}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/individualAccountRequestAuthorization"
                                    exact
                                    component={IndividualAccountRequest}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customerChangeRequestList"
                                    exact
                                    component={CustomerRequestsListPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/invest-money"
                                    exact
                                    component={InvestMoneyRequestsComp}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/withdraw-money"
                                    exact
                                    component={WithdrawMoneyRequestsComp}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/transfer-money"
                                    exact
                                    component={TransferMoneyRequestsComp}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/switch-money"
                                    exact
                                    component={SwitchMoneyRequestsComp}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/invest-reconcilation"
                                    exact
                                    component={InvestReconciliationPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/invest-reconciliation-authorization"
                                    exact
                                    component={InvestReconciliationAuth}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/invest-reconciliation-uploaded-excels"
                                    exact
                                    component={InvestReconciliationExcelView}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    path="/workflow/admin/customer-transaction-request/processing-invest-requests"
                                    exact
                                    component={InvestRetryRequestList}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/switch-request-admin"
                                    component={SwitchRequestPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/invest-request-admin"
                                    component={InvestRequestPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/transfer-request-admin"
                                    component={TransferRequestPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/withdraw-request-admin"
                                    component={WithdrawRequestPage}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/manage-parameters/fund-details"
                                    component={FundDetails}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/manage-parameters/table-resync"
                                    component={TableResync}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/joint-account-request-list"
                                    component={JointAccountRequestList}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/create-new-individual-account"
                                    component={IndividualAccountComp}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/create-new-joint-account"
                                    component={SecondApplicantData}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/joint-account-template-request-list"
                                    component={JointAccountTemplateRequestList}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/changeRequests"
                                    component={CustomerRequestsPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/switch-request"
                                    component={SwitchTemplatePage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/invest-request"
                                    component={InvestTemplatePage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/transfer-request"
                                    component={TransferTemplatePage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/withdraw-request"
                                    component={WithdrawTemplatePage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/transaction-history/:type"
                                    component={TransactionHistoryPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/change-password"
                                    component={ChangePassword}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/customer/third-party-bank-detail-templates"
                                    component={ExistingTemplate}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/relationship-manager-dashboard"
                                    component={RMDashboardPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/manager-dashboard"
                                    component={ManagerDashboard}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/all-customer-list"
                                    component={CustomerDetailsTablePage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/customer-details-view"
                                    component={CustomerDetailsViewPage}
                                />
                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/manage-parameters/admin-user-list"
                                    component={InternalUsersList}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/customer-transaction-history/:type"
                                    component={AdminTransactionHistoryPage}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/customer-journey-status"
                                    component={CustomerJourneyStatusPage}
                                />

                                <PrivateRoute
                                    roles={["view-user-details"]}
                                    exact
                                    path="/workflow/admin/customer-journey-status-view"
                                    component={CustomerJourneyStatusViewPage}
                                />
                            </Switch>
                        </MainLayout>
                    </Route>
                </Switch>
            </BrowserRouter>
        </>
    );
};
